import { MapperBase } from '../../utilities/mapper-base';
import { ActiveProcessingStepHistogram } from '../resource/active-processing-histogram.resource';
import { ProcessingStepsRow } from '../ui/queued-steps-row.model';

export class ActiveProcessingStepHistogramToProcessingStepsRowMapper extends MapperBase<ActiveProcessingStepHistogram, ProcessingStepsRow> {
	map(source: ActiveProcessingStepHistogram): ProcessingStepsRow {
		const dest = new ProcessingStepsRow();
		dest.caseName = source?.caseName;
		dest.stepCount = source?.functionCount;
		dest.stepName = source?.stepFunction?.displayName;
		dest.accountName = source?.accountName;
		return dest;
	}
}


